import { useLayoutEffect, useMemo, useRef } from 'react'
import debounce from 'lodash/debounce'

type Callback = (...args: any[]) => void

export default function useDebouncedCallback(callback: Callback, wait: number) {
  const latest = useRef(callback)
  useLayoutEffect(() => {
    latest.current = callback
  })

  return useMemo(() => debounce((...args: any[]) => latest.current(...args), wait), [wait])
}



// WEBPACK FOOTER //
// ./src/hooks/useDebouncedCallback/index.ts